import MainMenu from './main-menu-container';

export default MainMenu;
